import * as React from "react";
import { motion } from "framer-motion";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "ghost" | "secondary";
  size?: "default" | "sm" | "lg" | "icon";
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = "", variant = "default", size = "default", ...props }, ref) => {
    const baseStyles = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-xs font-black uppercase tracking-[0.15em] transition-all active:scale-95 disabled:pointer-events-none disabled:opacity-50 outline-none";
    
    const variants = {
      default: "bg-[var(--color-primary)] text-[var(--color-primary-black)] shadow-lg hover:bg-[var(--color-primary-orange-dark)] shadow-[var(--color-primary)]/20",
      outline: "border border-[var(--color-primary-orange)]/40 bg-transparent text-[var(--color-primary)] hover:bg-[var(--color-primary-orange)]/10 shadow-xl",
      ghost: "hover:bg-[var(--color-foreground)]/10 text-[var(--color-foreground)]/60 hover:text-[var(--color-foreground)]",
      secondary: "bg-[var(--color-primary-dark-gray)] text-[var(--color-foreground)] hover:bg-[var(--color-primary-gray)] shadow-lg"
    };

    const sizes = {
      default: "h-14 px-8",
      sm: "h-10 px-4",
      lg: "h-16 px-10",
      icon: "h-10 w-10"
    };

    const variantStyle = variants[variant] || variants.default;
    const sizeStyle = sizes[size] || sizes.default;

    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variantStyle} ${sizeStyle} btn-premium ${className}`}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";

export { Button };
